import React, {useEffect} from 'react';
import {Modal, Button, Form, Input, Select, Space, DatePicker} from 'antd';
import dayjs from "dayjs";

const {Option} = Select;

const FilterTable = ({
                       open,
                       onCancel,
                       onApply,
                       fields = [],      // array: [{ title, key, type?, options? }]
                       initialValues = {} // начални стойности при отваряне (по избор)
                     }) => {
  const [form] = Form.useForm();
  // Here we use useEffect to reset the form when the modal is opened
  useEffect(() => {
    if (open) {
      form.resetFields();
      // If initialValues are provided, set them in the form
      if (initialValues && Object.keys(initialValues).length) {
        const prepared = fields.reduce((acc, f) => {
          if (Object.prototype.hasOwnProperty.call(initialValues, f.key)) {
            const v = initialValues[f.key];
            if (f.type === 'date' && v) {
              acc[f.key] = typeof v === 'string' || typeof v === 'number' ? dayjs(v) : v;
            } else {
              acc[f.key] = v;
            }
          }
          return acc;
        }, {});
        form.setFieldsValue(prepared);
      }
    }
  }, [open, form, initialValues, fields]);

  const handleClear = () => {
    form.resetFields();
    if (onApply) onApply(null);
    if (onCancel) onCancel(true);
  };

  const handleApply = async () => {
    try {
      const values = await form.validateFields();
      // Remove undefined, null, and empty strings from the values object
      const filtered = Object.entries(values).reduce((acc, [k, v]) => {
        if (v !== undefined && v !== null && v !== '') acc[k] = v;
        return acc;
      }, {});
      if (onApply) onApply(filtered);
      if (onCancel) onCancel();
    } catch (e) {
      // Unique error handling for each field
    }
  };

  const renderField = (f) => {
    const {type = f.type || 'text', options = f.options || [], placeholder} = f;

    switch (type) {
      case 'select':
        return (
          <Select allowClear placeholder={placeholder || f.title}>
            {options.map(opt => (
              <Option key={opt.value} value={opt.value}>
                {opt.label}
              </Option>
            ))}
          </Select>
        );
      case 'date':
        return (<DatePicker allowClear placeholder={placeholder || f.title} format="DD.MM.YYYY"/>)
      default:
        // Default to Input for other types
        return <Input allowClear placeholder={placeholder || f.title}/>;
    }
  };

  return (
    <Modal
      title="Филтър"
      open={open}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        preserve={false}
        initialValues={initialValues}
      >
        {fields.map(f => (
          <Form.Item key={f.key} name={f.key} label={f.title}>
            {renderField(f)}
          </Form.Item>
        ))}

        <Space style={{display: 'flex', justifyContent: 'flex-end', width: '100%'}}>
          <Button onClick={handleClear}>
            Изчисти
          </Button>
          <Button onClick={onCancel}>
            Отказ
          </Button>
          <Button type="primary" onClick={handleApply}>
            Приложи
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default FilterTable;
